const auditActionLabels: Record<string, string> = {
 "organization.application.submit":"提交团队申请","organization.application.approved":"通过团队申请","organization.application.rejected":"团队申请未通过","organization.material.access":"查看团队资质","organization.members.generate":"生成团队成员账号","organization.credentials.receive":"查看初始登录信息","organization.credentials.renew":"重新生成失效登录信息","organization.member.status":"调整团队成员状态","organization.member.password.reset":"重置团队成员密码","organization.update":"调整团队状态与额度","auth.password.login":"账号密码登录","auth.password.change":"修改账号密码","enrollment.grant.organization":"使用团队权益报名",

  'identity.admin.create': '新增管理员',
  'identity.admin.update': '编辑管理员资料与角色',
  'identity.admin.roles.update': '分配管理员角色',
  'identity.admin.status.update': '调整管理员状态',
  'identity.role.create': '新增管理角色',
  'identity.role.update': '编辑管理角色',
  'identity.role.delete': '删除管理角色',

  'engagement.recommendation.order': '调整首页推荐顺序',
  'engagement.recommendation.schedule_removed': '取消首页推荐时间限制',
  'engagement.recommendation.create': '添加课程推荐',
  'engagement.recommendation.update': '更新课程推荐',
  'auth.phone.login': '手机号登录',
  'course.category.create': '新建课程分类',
  'course.category.update': '编辑课程分类',
  'course.category.delete': '删除课程分类',
  'course.create': '新建课程',
  'course.update': '编辑课程',
  'course.pending_review': '提交课程审核',
  'course.revision.approved': '课程修订审核通过',
  'course.revision.changes_requested': '课程修订退回修改',
  'course.revision.submit': '课程修订送审',
  'course.approved': '课程审核通过',
  'course.changes_requested': '课程退回修改',
  'course.chapter.create': '新建课程章节',
  'course.chapter.update': '编辑课程章节',
  'course.chapter.delete': '删除课程章节',
  'course.chapter.reorder': '调整课程章节顺序',
  'course.lesson.create': '新建课时',
  'course.lesson.update': '编辑课时',
  'course.lesson.delete': '删除课时',
  'course.lesson.reorder': '调整课时顺序',
  'course.lesson.asset.create': '添加课时资源',
  'course.lesson.asset.update': '编辑课时资源',
  'course.lesson.asset.delete': '删除课时资源',
  'teacher.application.approved': '教师申请审核通过',
  'teacher.application.rejected': '教师申请审核拒绝',
  'teacher.application.submit': '提交教师申请',
  'teacher.application.material.access': '查看教师申请材料',
  'course.review.approved': '课程审核通过',
  'course.review.changes_requested': '课程要求修改',
  'course.published': '课程发布',
  'course.unpublished': '课程下架',
  'user.status.suspended': '冻结用户',
  'user.status.active': '恢复用户',
  'refund.approved': '退款审核通过',
  'refund.rejected': '退款审核拒绝',
  'finance.settlement.dispute_resolved': '处理结算异议并交回教师确认',
  'finance.settlement.confirm': '教师确认结算单',
  'finance.settlement.dispute': '教师提出结算异议',
  'finance.settlement.pay': '记录结算付款',
  'finance.settlement.generate': '生成教师结算单',
  'enrollment.grant.free': '免费报名课程',
  'enrollment.grant.admin': '管理员发放课程资格',
  'file.upload.request': '申请上传文件',
  'file.upload.confirm': '确认文件上传完成',
  'classroom.draft.create': '新建课堂草稿',
  'classroom.update': '编辑课堂',
  'classroom.prepare': '准备开课',
  'classroom.publish': '发布课堂',
  'classroom.start': '开始课堂',
  'classroom.recording.reconcile': '核对并恢复回放',
  'classroom.recording.recovered': '回放文件核对完成',
  'classroom.end': '结束课堂',
  'classroom.cancel': '取消课堂',
  'menu.classroom.manage': '强制结束课堂',
  'classroom.question.answer': '回答课堂提问',
  'banner.reorder': '调整 Banner 顺序',
  'finance.gift.create': '创建直播礼物',
  'finance.gift.update': '修改直播礼物',
  'finance.gift.delete': '删除直播礼物',
  'banner.create': '创建首页 Banner',
  'banner.update': '修改首页 Banner',
  'banner.enabled': '上线首页 Banner',
  'banner.disabled': '下线首页 Banner',
  'banner.delete': '删除首页 Banner',
  'course_group.announcement.发布': '发布课程群公告',
  'course_group.announcement.withdraw': '撤回课程群公告',
  'course_group.join': '加入课程群',
  'course_group.leave': '退出课程群',
  'course_group.resync': '重新同步课程群',
  'teaching.assignment.create': '新建作业',
  'teaching.assignment.update': '编辑作业',
  'teaching.assignment.publish': '发布作业',
  'teaching.assignment.review': '批阅作业',
  'teaching.questionnaire.create': '新建问卷',
  'teaching.questionnaire.update': '编辑问卷',
  'teaching.questionnaire.publish': '发布问卷',
  'teaching.questionnaire.stop': '停止问卷',
  'teaching.questionnaire.export': '导出问卷结果',
  'account.onboarding.update': '更新个人资料',
  'account.deletion.request': '申请注销账号',
  'account.deletion.cancel': '取消注销账号',
  'finance.wallet.adjust': '调整用户余额',
  'wallet.recharge.create': '创建余额充值订单',
  'commerce.payment.callback.success': '支付成功',
}

const auditResourceLabels: Record<string, string> = {
  user: '用户', user_onboarding: '用户资料', account_deletion: '账号注销申请',
  admin_membership: '管理员', role: '管理角色', teacher_profile: '教师资质',
  course: '课程', course_category: '课程分类', enrollment: '报名记录',
  classroom: '课堂', classroom_question: '课堂提问', course_group: '课程群',
  assignment: '作业', assignment_submission: '作业提交', questionnaire: '问卷',
  order: '订单', refund: '退款', settlement_period: '结算周期', settlement_statement: '教师结算单',
  wallet: '用户钱包', gift: '礼物', file_asset: '文件', content_report: '内容举报',
  notification_campaign: '通知任务', system_config: '系统配置', outbox_delivery: '消息投递',
  organization: '团队', organization_application: '团队申请', organization_batch: '成员生成批次', homepage_banner: '首页 Banner', data_export: '数据导出', course_recommendation: '课程推荐', support_ticket: '用户反馈',
}

const auditTokenLabels: Record<string, string> = {
  create: '新建', update: '编辑', delete: '删除', publish: '发布', unpublished: '下架',
  approved: '审核通过', rejected: '审核拒绝', pending_review: '提交审核', changes_requested: '退回修改',
  request: '申请', cancel: '取消', confirm: '确认', generate: '生成', export: '导出',
  assign: '分派', reply: '回复', resolve: '处理', review: '审核', submit: '提交',
  start: '开始', end: '结束', stop: '停止', prepare: '准备', terminate: '强制结束',
  join: '加入', leave: '退出', resync: '重新同步', bind: '绑定', unbind: '解绑',
  active: '启用', suspended: '冻结', success: '成功', succeeded: '成功', free: '免费', admin: '管理员',
}

export function getAuditActionLabel(action: string) {
  if (auditActionLabels[action]) return auditActionLabels[action]
  const translated = action.split('.').map((token) => auditResourceLabels[token] ?? auditTokenLabels[token]).filter(Boolean)
  return translated.length ? translated.join(' · ') : '其他管理操作'
}

export function getAuditResourceLabel(resource: string) {
  return auditResourceLabels[resource] ?? '其他业务对象'
}
